// utils.ts — keep these
import { Location } from 'react-router-dom'

export const getSegmentFromTab = (value: number, segments: readonly string[]) => segments[value] ?? 'main'

export const getCurrentTabSegment = (location: Location, segments: string[]) =>
  segments.find(seg => location.pathname.includes('/' + seg)) ?? 'main'

// ❌ remove this old one (it’s index-based and wrong for NCO)
// export const showsActions = (v: number | string) => v === 0 || v === 2 || v === 3;

export const ACTIONS = {
  edit: 'action-edit',
  save: 'action-save',
  cancel: 'action-cancel',
  saveChk: 'action-save-checklist',
} as const

// import { Location } from 'react-router-dom'

// export const getSegmentFromTab = (value: number, segments: readonly string[]) => segments[value] ?? 'main'
// export const getCurrentTabSegment = (location: Location, segments: string[]) =>
//   segments.find(seg => location.pathname.includes('/' + seg)) ?? 'main'

// export const showsActions = (v: number | string) => v === 0 || v === 2 || v === 3
// export const ACTIONS = {
//   edit: 'action-edit',
//   save: 'action-save',
//   cancel: 'action-cancel',
//   saveChk: 'action-save-checklist',
// }
